// parallax keyvisual & headline

import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

/**gsap.to(".c-keyvisual", {
  backgroundPositionY: -500,
  ease: "none",
  scrollTrigger: {
    scrub: true
  }
});*/

gsap.to(".c-headline", {
  yPercent: -200,
  ease: "none",
  scrollTrigger: {
    scrub: true
  } 
});